import { renderModel } from './renderModel';

class NavigationControl {
  public isLocked: boolean;
  private readonly isWidget: boolean;

  constructor(isWidget: boolean) {
    this.isLocked = false;
    this.isWidget = isWidget;
  }

  private handleUnload(event: BeforeUnloadEvent) {
    event.preventDefault();
    event.stopPropagation();
    event.returnValue = '';
  }

  lock() {
    if (process.env.NODE_ENV === 'development') {
      return;
    }

    if (this.isWidget) {
      return;
    }

    window.onbeforeunload = this.handleUnload;
    this.isLocked = true;
  }

  unlock() {
    window.onbeforeunload = null;
    this.isLocked = false;
  }

  reload() {
    this.unlock();
    location.reload();
  }
  // for old chatbot full page @todo remove this after old chatbot is deprecated
  to(url: string, inNewTab: boolean): void {
    if (inNewTab) {
      window.open(url, '_blank');
      return;
    }

    this.unlock();
    location.href = url;
  }
}

export const navigationControl = new NavigationControl(renderModel.isWidget());
